import type * as React from 'react';
import { cn } from '@/lib/utils';

export function SectionHeading({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2
      className={cn(
        'flex h-10 items-center font-sans text-[16px] font-light uppercase leading-5 tracking-normal text-[rgba(0,0,0,0.87)]',
        className,
      )}
      {...props}
    />
  );
}
